import React, { Component, MouseEvent } from "react";
import dog from "./GettyImages-1445770180.jpg"
import cat from "./728px-What_kind_of_cat_am_i.jpeg"

type StartPageProps = {
    /// asks parent to begin quiz
    onStartClick: () => void;
}

export class StartPage extends Component<StartPageProps> {
    render = (): JSX.Element => {
        return (
            <div className="start">
                <h1>Are you a dog or a cat?</h1>
                <img src={dog} className="dog" alt="dog"/>
                <img src={cat} className="cat" alt="cat"/>
                <p></p>
                <button type="button" onClick={this.doStartClick}>Start Quiz</button>
            </div>
        );
    }

    // Updates UI to quiz page
    doStartClick = (_evt: MouseEvent<HTMLButtonElement>): void => {
        this.props.onStartClick();
    }
}